<template>
  <PageContainer>
    <h1>{{ user?.name }}</h1>
    <p>{{ user?.id }}</p>
    <pre>{ purpose: {{ user?.purpose }}, zone: {{ user?.zone }}, hasDataSource(): {{ user?.hasDataSource }} }</pre>
    <div v-if="success" @click="clearSuccess()" class="w-full mt-4 p-4 bg-theme-teal-bg rounded-md cursor-pointer">
      <span class="font-bold">Success: </span>{{ success }}
    </div>
    <button v-if="!confirmDelete && !confirmClear" @click="confirmClear = true" class="bg-orange ring-4 ring-transparent mx-1">Clear data</button>
    <button v-else-if="confirmClear" @click="clearData()" class="bg-orange animate-pulse ring-4 ring-orange-200">Confirm data clear?</button>
    <button v-if="!confirmDelete && !confirmClear" @click="confirmDelete = true" class="bg-red ring-4 ring-transparent mx-1">Delete user</button>
    <button v-else-if="confirmDelete" class="bg-red animate-pulse ring-4 ring-red-200">Confirm deletion?</button>
    <button v-if="confirmDelete || confirmClear" @click="confirmDelete = false; confirmClear = false" class="bg-gray-300 hover:bg-gray-300 mx-3">Cancel</button>

    <h2>Target</h2>
    <div class="max-h-96 overflow-y-scroll border">
      <pre>{{ pretty(user?.target) }}</pre>
    </div>

    <h2>Plans</h2>
    <p>All plans, both active and inactive</p>
    <div class="max-h-96 overflow-y-scroll border">
      <pre>[</pre>
      <pre v-for="p in plans" :key="p">  {{ pretty(p, '  ') }},</pre>
      <pre>]</pre>
    </div>

    <h2>Streaks</h2>
    <p>All associated streaks from the plans</p>
    <div class="max-h-96 overflow-y-scroll border">
      <pre>[</pre>
      <pre v-for="s in streaks" :key="s">  {{ pretty(s, '  ') }},</pre>
      <pre>]</pre>
    </div>

    <h2>Sleeps</h2>
    <p>Last 30 days</p>
    <div class="max-h-96 overflow-y-scroll border">
      <pre>[</pre>
      <pre v-for="s in sleeps" :key="s">  {{ pretty(s, '  ') }},</pre>
      <pre>]</pre>
    </div>
  </PageContainer>
</template>

<script>
import PageContainer from '@/components/PageContainer'
import User from '@/models/user'
import Plan from '@/models/plan'

export default {
  name: 'AdminUserPage',
  components: {
    PageContainer,
  },
  props: {
  },
  emits: [
  ],
  data() {
    return {
      user: undefined,
      success: null,
      confirmDelete: false,
      confirmClear: false,
      plans: undefined,
      streaks: undefined,
      sleeps: undefined,
    }
  },
  beforeMount() {
    this.loadUser()
  },
  watch: {
    success() {
      this.loadUser()
    },
  },
  methods: {
    async loadUser() {
      const uid = this.$route.query.u
      this.user = await User.get(uid)
      this.plans = await Plan.getByUser(uid)
      const stages = this.plans.map(p => p.stages).flat()
      this.streaks = await Promise.all(stages.map(async stage => await stage.streak))
      let d = new Date()
      this.sleeps = await this.user.getSleeps(d.setDate(d.getDate() - 30), new Date())
      // Fill out consistency scores and remove data field.
      this.sleeps = await Promise.all(this.sleeps.map(async sleep => { 
        sleep.consistency_score = await sleep.consistency
        delete sleep.breakdown.data
        return sleep
      }))
    },
    async clearData() {
      await this.user.clear()
      this.confirmClear = false
      this.success = 'Cleared all data.'
    },
    pretty(object, linePrefix='') {
      // Remove unnecessary and hidden variables (those prefixed with _).
      let copy = {}
      for (let key in object) {
        if (!key.startsWith('_') && key != 'apiServiceUser' && key != 'uuid') {
          copy[key] = object[key]
        }
      }
      return JSON.stringify(copy, null, 2).replaceAll('\n', '\n' + linePrefix)
    },
    clearSuccess() {
      this.success = null
    },
  },
  computed: {
  },
}
</script>

<style scoped>
  h2 {
    margin-top: 2rem;
  }
  pre {
    font-size: 10pt;
    text-align: left;
    text-wrap: wrap;
  }
</style>